module.exports = __webpack_public_path__ + "static/media/alcon3.63a94610.png";